<template>
  <section class="px-16 py-28 max-[1024px]:p-[4rem_1.25rem]">
    <div class="flex justify-between gap-20 max-[1024px]:flex-col max-[1024px]:gap-12">
      <div class="flex-auto w-min flex flex-col gap-8 justify-center min-w-[26.25rem] max-[1024px]:min-w-0 max-[1024px]:w-auto max-[1024px]:gap-4">
        <div class="flex gap-4 items-center">
          <Tag tag="Article Guides" />
          <span class="text-[0.875rem] leading-[1.25rem]">{{ readTime }} min read</span>
        </div>
        <h2 class="m-0 text-[3rem] leading-[3.625rem] max-[1024px]:text-[2.25rem] max-[1024px]:leading-[2.6875rem]">
          {{ title }}
        </h2>
      </div>
      <img
        :src="headerImageUrl"
        class="min-w-[20.9375rem] max-h-[28.125rem] aspect-[812/450] object-cover overflow-hidden rounded-xl"
      />
    </div>
  </section>
</template>
<script>
import Tag from '../tag/index.vue'
export default {
  name: 'RefrigeratedBuyersGuideHeader',
  components: {
    Tag
  },
  props: {
    title: {
      type: String,
      required: true
    },
    headerImageUrl: {
      type: String,
      default: ''
    },
    readTime: {
      type: Number,
      default: 5
    }
  }
}
</script>

<style lang="scss" scoped>
.fill-available {
  width: -webkit-fill-available;
  width: -moz-available;
  width: fill-available;
  width: available;
}
</style>